export class CallsToAction {
    callsToAction: CallToAction[]
    indexOfFirstCta: number
    pairingsCount: number

    constructor(callsToAction: CallToAction[], pairingsCount: number, indexOfFirstCta: number = 0) {
        this.callsToAction = callsToAction
        this.indexOfFirstCta = indexOfFirstCta
        this.pairingsCount = pairingsCount
    }

    callToActionAtIndex(index: number): CallToAction | null {
        if (this.callsToAction.length === 0) {
            // we have no calls to action, how sad
            return null
        }

        if (index === this.indexOfFirstCta) {
            return this.callsToAction[0] ?? null
        }

        const interval = Math.floor(
            (this.pairingsCount - this.indexOfFirstCta) / this.callsToAction.length,
        )

        if (index % interval !== 0) {
            return null
        }

        return this.callsToAction[index / interval] ?? null
    }
}
